/*
 * iKrush social-proof pill (<social-proof-pill>, snippets/social-proof-pill.liquid).
 *
 * Shows real counts only; this file never changes a number. It:
 *  - keeps the pill hidden when the data is over 6 hours old (the hourly job
 *    stopped), because "in the last 48 hours" would no longer be true;
 *  - runs the PostHog A/B test: flag "social-proof-pill" = "control" keeps it
 *    hidden, "pill" shows it; both arms fire social_proof_exposure. If PostHog
 *    is blocked or slow (1.5 s), the pill shows and the shopper isn't in the test;
 *  - rotates messages (none with prefers-reduced-motion) and fires
 *    social_proof_shown once per message per page view.
 * A custom element, so it re-initialises when the product section re-renders.
 */
(function (root) {
  "use strict";

  var STALE_MS = 6 * 60 * 60 * 1000;
  var FLAG = "social-proof-pill";
  var FLAG_TIMEOUT_MS = 1500;

  function isStale(generatedAt, nowMs) {
    var t = Date.parse(generatedAt || "");
    return !isFinite(t) || nowMs - t > STALE_MS;
  }

  function decide(flag) {
    if (flag === "control") return { show: false, arm: "control" };
    if (flag === "pill") return { show: true, arm: "pill" };
    return { show: true, arm: null };
  }

  if (typeof module !== "undefined" && module.exports) {
    module.exports = { isStale: isStale, decide: decide, STALE_MS: STALE_MS, FLAG: FLAG };
    return;
  }

  function capture(name, props) {
    if (root.posthog && typeof root.posthog.capture === "function") root.posthog.capture(name, props);
  }

  function whenFlag(cb) {
    var done = false;
    function finish(v) { if (!done) { done = true; cb(v); } }
    var ph = root.posthog;
    if (!root.IKRUSH_PH || !ph || typeof ph.onFeatureFlags !== "function") return finish(undefined);
    setTimeout(function () { finish(undefined); }, FLAG_TIMEOUT_MS);
    ph.onFeatureFlags(function () { finish(ph.getFeatureFlag(FLAG)); });
  }

  class SocialProofPill extends HTMLElement {
    connectedCallback() {
      if (this._started) return;
      this._started = true;
      if (isStale(this.dataset.generatedAt, Date.now())) return;
      var self = this;
      whenFlag(function (flag) {
        var d = decide(flag);
        if (d.arm) capture("social_proof_exposure", { product_id: self.dataset.productId, variant: d.arm });
        if (d.show) self.start();
      });
    }

    disconnectedCallback() {
      clearInterval(this._timer);
    }

    start() {
      var items = this.querySelectorAll("[data-message]");
      if (!items.length) return;
      this.hidden = false;
      var self = this, seen = {}, i = 0;
      function show(idx) {
        for (var j = 0; j < items.length; j++) items[j].classList.toggle("is-active", j === idx);
        if (!seen[idx]) {
          seen[idx] = true;
          capture("social_proof_shown", {
            product_id: self.dataset.productId,
            type: items[idx].dataset.type,
            count: Number(items[idx].dataset.count),
          });
        }
      }
      show(0);
      var reduce = root.matchMedia && root.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (items.length < 2 || reduce) return;
      var secs = Math.min(10, Math.max(3, Number(this.dataset.rotateSeconds) || 5));
      this._timer = setInterval(function () { i = (i + 1) % items.length; show(i); }, secs * 1000);
    }
  }

  if (!root.customElements.get("social-proof-pill")) root.customElements.define("social-proof-pill", SocialProofPill);
})(typeof window !== "undefined" ? window : globalThis);
